import { SvgIcon, useTheme } from "@mui/material";
import { getIconSize } from "../bcp/BCPIcons";
const defaultSize = 22;

export function CatanCard(props) {
  const { sx, size, style, color, ...rest } = props;

  const iconSize = getIconSize(size);
  const iconNum = parseInt(iconSize.replace("px", "")) || defaultSize;

  const theme = useTheme();

  return (
    <SvgIcon
      sx={{
        ...sx,
        ...style,
        width: iconSize,
        height: iconSize,
      }}
      {...rest}
    >
      <svg
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox={`0 0 ${iconNum} ${iconNum}`}
        width={iconSize}
        height={iconSize}
        fill={
          color ||
          style?.color ||
          sx?.color ||
          theme?.palette?.text?.primary ||
          "#010101"
        }
      >
        <defs id="defs3"></defs>
        <path
          d="m 4.9337183,15.829099 c -0.3,-0.7 -0.5,-1.4 -0.5,-2.2 0,-2.8 2.3,-4.9999997 5.0000003,-4.9999997 2.8000004,0 5.0000004,2.2999997 5.0000004,4.9999997 0,0.8 -0.2,1.6 -0.5,2.2 z M 18.233719,1.8290993 V 25.729099 c 0,0.6 -0.4,1 -1,1 H 1.8337183 c -0.6,0 -1.00000001,-0.4 -1.00000001,-1 V 1.8290993 c 0,-0.6 0.40000001,-1.00000003 1.00000001,-1.00000003 H 17.233719 c 0.6,0 1,0.50000003 1,1.00000003 z m -2.3,11.7999997 c 0,-3.6 -2.9,-6.4999997 -6.5000004,-6.4999997 -3.6000003,0 -6.5000003,2.8999997 -6.5000003,6.4999997 0,3.6 2.9,6.5 6.5000003,6.5 3.6000004,0 6.5000004,-2.9 6.5000004,-6.5 z"
          id="path3"
        />
      </svg>
    </SvgIcon>
  );
}

export function CatanKnight(props) {
  const { sx, size, style, color, ...rest } = props;

  const iconSize = getIconSize(size);
  const iconNum = parseInt(iconSize.replace("px", "")) || defaultSize;

  const theme = useTheme();

  return (
    <SvgIcon
      sx={{
        ...sx,
        ...style,
        width: iconSize,
        height: iconSize,
      }}
      {...rest}
    >
      <svg
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox={`0 0 ${iconNum} ${iconNum}`}
        width={iconSize}
        height={iconSize}
        fill={
          color ||
          style?.color ||
          sx?.color ||
          theme?.palette?.text?.primary ||
          "#010101"
        }
      >
        <defs id="defs3"></defs>
        <path
          d="m 12.943564,1.3891089 c 0.4,0.2 0.7,0.7 1.2,0.9 2.1,1.2 3.5,1.2 5.2,3.3 1.6,2 2.2,4.5000001 2.2,7.1000001 0,3.1 -1.6,8.8 0.3,11.5 0.5,0.8 1.7,0.7 0.7,1.9 -1.9,2.4 -7.8,4.6 -9.2,-0.7 l -0.3,-9.1 c 0.2,-1.2 3.7,-0.4 4.4,-1.1 0.6,-0.6 0.4,-2.3 -0.3,-2.7 -1.7,0.3 -3.5,0.3 -5.2,0.3 -1.7,0 -3.4999996,0 -5.1999996,-0.3 -0.7,0.4 -0.9,2.1 -0.3,2.7 0.7,0.7 4.1999996,-0.1 4.3999996,1.1 l -0.3,9.1 c -1.3999996,5.3 -7.2999996,3.1 -9.1999996,0.7 -1.00000004,-1.3 0.2,-1.2 0.7,-1.9 1.8,-2.7 0.3,-8.4 0.3,-11.5 0,-2.5 0.6,-5.1000001 2.2,-7.1000001 1.7,-2.1 3.1,-2.1 5.2,-3.3 0.4999996,-0.3 0.7999996,-0.7 1.1999996,-0.9 0.3,-0.2 0.6,-0.2 0.9,-0.2 0.7,0 1.1,0.2 1.1,0.2 z"
          id="path1"
        />
      </svg>
    </SvgIcon>
  );
}

export function CatanRoad(props) {
  const { sx, size, style, color, ...rest } = props;

  const iconSize = getIconSize(size);
  const iconNum = parseInt(iconSize.replace("px", "")) || defaultSize;

  const theme = useTheme();

  return (
    <SvgIcon
      sx={{
        ...sx,
        ...style,
        width: iconSize,
        height: iconSize,
      }}
      {...rest}
    >
      <svg
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox={`0 0 ${iconNum} ${iconNum}`}
        width={iconSize}
        height={iconSize}
        fill={
          color ||
          style?.color ||
          sx?.color ||
          theme?.palette?.text?.primary ||
          "#010101"
        }
      >
        <defs id="defs1" />
        <g transform="translate(-90.1968,-20.7137)" id="g1">
          <path
            d="m 109.3,48.5 h -18 c 0,0 10.5,-7.1 9,-10.6 -1.5,-3.5 -7.8,-4.5 -2.8,-9.4 5,-4.9 11.8,-5.9 11.8,-5.9 h 1.3 c 0,0 -12.4,7.6 -6.6,10.1 5.7,2.6 13.3,5.1 5.3,15.8 z"
            id="path1"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}

export function CatanTimer(props) {
  const { sx, size, style, color, ...rest } = props;

  const iconSize = getIconSize(size);
  const theme = useTheme();

  return (
    <SvgIcon
      sx={{
        ...sx,
        ...style,
        width: iconSize,
        height: iconSize,
      }}
      {...rest}
    >
      <svg
        data-v-de517a04=""
        data-v-eff37610=""
        version="1.1"
        viewBox="0 0 430 512"
        width={iconSize}
        height={iconSize}
        fill={
          color ||
          style?.color ||
          sx?.color ||
          theme?.palette?.text?.primary ||
          "#010101"
        }
      >
        <g data-v-de517a04="">
          <path
            data-v-de517a04=""
            class="fgFill"
            d="m346.27 323.9c19.648 23.686 19.73 60.098 19.73 60.098v86h43s21 0 21 21-21 21-21 21h-388s-21 0-21-21 21-21 21-21h43v-86s0.08223-36.413 19.73-60.098c24.814-29.545 59.038-47.809 91.27-67.902-32.232-20.093-66.455-38.356-91.27-67.902-19.648-23.686-19.73-60.098-19.73-60.098v-86h-43s-21 0-21-21 21-21 21-21h388s21 0 21 21c0 21-21 21-21 21h-43v86s-0.0822 36.413-19.73 60.098c-24.814 29.545-59.038 47.809-91.27 67.902 32.232 20.093 66.455 38.356 91.27 67.902z"
          ></path>
        </g>
        <g data-v-de517a04="">
          <g
            class="bgStroke"
            stroke-linecap="round"
            stroke-width="26"
            data-v-de517a04=""
          >
            <path
              d="m100.62 103.55a159 159 0 0 1 114.38-48.549 159 159 0 0 1 114.38 48.549"
              data-v-de517a04=""
            ></path>
            <path
              d="m136.59 138.98a109 108 0 0 1 78.408-32.977 109 108 0 0 1 78.408 32.977"
              data-v-de517a04=""
            ></path>
            <path
              d="m171.12 174.02a61 59 0 0 1 43.88-18.015 61 59 0 0 1 43.88 18.015"
              data-v-de517a04=""
            ></path>
          </g>
          <circle
            class="bgFill"
            cx="215"
            cy="211"
            r="16"
            data-v-de517a04=""
          ></circle>
        </g>
        <g data-v-de517a04="">
          <g
            data-v-de517a04=""
            class="bgFill"
            transform="matrix(1.82 0 0 1.87 124 283)"
          >
            <path
              data-v-de517a04=""
              d="m37.947 95.503c-1.696 2.603-2.865 4.492-6.152 4.492-7.276 0-10.582 5e-3 -18.858 5e-3 -4.563 0-5.883-0.911-5.207-5.606 2.074-14.405 19.606-34.951 16.346-38.495-3.727-4.049-25.597 3.017-26.173-10.741-0.577-13.757 34.329-17.17 35.756-18.738 0.711-0.78-1.5192-24.296 16.342-24.281 17.861-0.015 15.631 23.501 16.342 24.281 1.427 1.568 36.333 4.9809 35.756 18.738-0.576 13.758-22.446 6.692-26.173 10.741-3.26 3.544 14.272 24.09 16.346 38.495 0.676 4.695-0.644 5.606-5.207 5.606-8.276 0-11.582-5e-3 -18.858-5e-3 -3.287 0-4.456-1.889-6.152-4.492-3.754-5.762-9.5861-16.894-12.053-16.893-2.467-1e-3 -8.2991 11.131-12.053 16.893z"
            ></path>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}
